import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as urls from '../utility/urls';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(
    private http: HttpClient,
  ) { }

  subscribeUser(email: string): Observable<any> {
    return this.http.post<any>(environment.myPerfitApi + urls.subscribeUserMO,
      {
        'email': email,
        "customFields": [
          {
            "id": 11,
            "value": "kozaca"
          }
        ],
        "lists": [
          {
            "id": 12
          }
        ]
      }
    )
  }
}
